import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
const initialFieldValues = {
  clientId: "00000000-0000-0000-0000-000000000000",
  staffId: "00000000-0000-0000-0000-000000000000",
  statusOfClient: "",
  clientCode: "",
  clientGroupCode: "",
  panNumber: "",
  clientName: "",
  companyName: "",
  email: "",
  address: "",
  phoneNumber: "",
  dateOfBirth: "",
  isActive: "",
};
export default function AllClients() {
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [userCompanyId, setUserCompanyId] = useState("");
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [staff, setStaff] = useState([]);
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
        dateOfBirth: recordForEdit.dateOfBirth
          ? moment(recordForEdit.dateOfBirth).format("YYYY-MM-DD")
          : "",
      });
    }
  }, [recordForEdit]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setShowAddClientModal(true);
  };
  const showClientDetails = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };
  const closeAddClientModal = () => {
    setShowAddClientModal(false);
    resetForm();
    setRecordForEdit(null);
  };
  const closeModal = () => {
    setSelectedClient(null);
    setShowModal(false);
  };
  const handleClearSearch = () => {
    setSearchKeyword("");
    GetData(pageNumber);
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const validate = () => {
    let temp = {};
    temp.panNumber = values.panNumber === "" ? false : true;
    temp.clientCode = values.clientCode === "" ? false : true;
    temp.clientName = values.clientName === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    temp.address = values.address === "" ? false : true;
    temp.isActive = values.isActive === "" ? false : true;
    temp.staffId =
      values.staffId === "00000000-0000-0000-0000-000000000000" ? false : true;
    temp.email = values.email === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("clientId", values.clientId);
      formData.append("statusOfClient", values.statusOfClient || "");
      formData.append("clientCode", values.clientCode);
      formData.append("clientGroupCode", values.clientGroupCode || "");
      formData.append("panNumber", values.panNumber);
      formData.append("clientName", values.clientName);
      formData.append("companyName", values.companyName || "");
      formData.append("email", values.email);
      formData.append("address", values.address);
      formData.append("dateOfBirth", values.dateOfBirth || "");
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("isActive", values.isActive);
      formData.append("staffId", values.staffId);
      formData.append("companyId", userCompanyId);
      addOrEdit(formData);
    }
  };
  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(config.APIACTIVATEURL + config.CREATECLIENT, newrecord, {
          ...headerconfig,
        }),
      update: (updateRecord) =>
        axios.put(config.APIACTIVATEURL + config.UPDATECLIENT, updateRecord, {
          ...headerconfig,
        }),
    };
  };
  const addOrEdit = (formData) => {
    if (formData.get("clientId") === "00000000-0000-0000-0000-000000000000") {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
            setShowAddClientModal(false);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
            setShowAddClientModal(false);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETALLCLIENTSDATA +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize,
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETECLIENT + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
            resetForm();
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
            resetForm();
          }
        });
    }
  };
  const searchClients = (keyword) => {
    if (keyword === "") {
      GetData(pageNumber);
    } else {
      axios
        .get(
          config.APIACTIVATEURL +
            config.SEARCHCLIENT +
            "?userId=" +
            userId +
            "&keyword=" +
            keyword,
          {
            ...headerconfig,
          }
        )
        .then((response) => {
          setLists(response.data);
        });
    }
  };
  const GetStaff = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        const resData = response.data.data;
        setStaff(resData);
      });
  };
  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetData(pageNumber);
    GetStaff();
    GetUserData();
  }, []);
  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">CLIENTS</h4>
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowAddClientModal(true)}
                  >
                    Add Client
                  </button>
                </div>
              </div>
            </div>
            <div className="row mt-6">
              <div className="col-12">
                <div className="p-3 border rounded shadow bg-white">
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control me-3"
                      style={{ maxWidth: "70%" }}
                      placeholder="Search......."
                      value={searchKeyword}
                      onChange={(e) => {
                        const keyword = e.target.value;
                        setSearchKeyword(keyword);
                        searchClients(keyword);
                      }}
                    />
                    <button
                      className="btn btn-danger me-2"
                      style={{ width: "120px" }}
                      type="button"
                      onClick={handleClearSearch}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              show={showAddClientModal}
              onHide={closeAddClientModal}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {values.clientId === "00000000-0000-0000-0000-000000000000"
                    ? "Add Client"
                    : "Edit Client"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="statusOfClient" className="form-label">
                          Client Status*
                        </label>
                        <select
                          value={values.statusOfClient}
                          name="statusOfClient"
                          onChange={handleInputChange}
                          className={
                            "form-select " + applyErrorClass("statusOfClient")
                          }
                        >
                          <option value="">Please select</option>
                          <option value="INDIVIDUAL">INDIVIDUAL</option>
                          <option value="PROPRIETOR">PROPRIETOR</option>
                          <option value="HUF">HUF</option>
                          <option value="AOP">AOP</option>
                          <option value="AOP(TRUST)">AOP(TRUST)</option>
                          <option value="CO-OPERATIVE ">CO-OPERATIVE</option>
                          <option value="FIRM">FIRM</option>
                          <option value="PRIVATE LTD">PRIVATE LTD</option>
                          <option value="PUBLIC LTD">PUBLIC LTD</option>
                          <option value="BOI">BOI</option>
                          <option value="LOCAL AUTHORITY">
                            LOCAL AUTHORITY
                          </option>
                          <option value="ARTIFICAIAL JURIDICAL PERSON">
                            ARTIFICAIAL JURIDICAL PERSON
                          </option>
                        </select>
                        {errors.statusOfClient === false ? (
                          <div className="validationerror">Please select</div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="clientCode" className="form-label">
                          Client Code*
                        </label>
                        <input
                          type="text"
                          name="clientCode"
                          value={values.clientCode}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("clientCode")
                          }
                          placeholder="e.g.ABC012"
                          maxLength={6}
                        />
                        {errors.clientCode === false ? (
                          <div className="validationerror">
                            Please enter code{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="clientGroupCode" className="form-label">
                          Group Code
                        </label>
                        <input
                          type="text"
                          name="clientGroupCode"
                          value={values.clientGroupCode}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("clientGroupCode")
                          }
                          placeholder="e.g-HYD1"
                          maxLength={10}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="panNumber" className="form-label">
                          PAN Number*
                        </label>
                        <input
                          type="text"
                          name="panNumber"
                          value={values.panNumber}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("panNumber")
                          }
                          placeholder="e.g-ABCDE1234F"
                          maxLength={10}
                        />
                        {errors.panNumber === false ? (
                          <div className="validationerror">
                            Please enter pannumber{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="clientName" className="form-label">
                          Client Name*
                        </label>
                        <input
                          type="text"
                          value={values.clientName}
                          name="clientName"
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("clientName")
                          }
                          placeholder="Please Enter Name"
                        />
                        {errors.clientName === false ? (
                          <div className="validationerror">
                            Please enter clientname{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="dateOfBirth" className="form-label">
                          Date of Birth
                        </label>
                        <input
                          type="date"
                          name="dateOfBirth"
                          value={values.dateOfBirth}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("dateOfBirth")
                          }
                          max={moment().format("YYYY-MM-DD")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="companyName" className="form-label">
                          Company Name
                        </label>
                        <input
                          type="text"
                          value={values.companyName}
                          name="companyName"
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("companyName")
                          }
                          placeholder="Please Enter Name"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                          Email*
                        </label>
                        <input
                          type="text"
                          name="email"
                          value={values.email}
                          onChange={handleInputChange}
                          className={"form-control " + applyErrorClass("email")}
                          placeholder="Please Enter Email"
                        />
                        {errors.email === false ? (
                          <div className="validationerror">
                            Please enter email{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">
                          Phone Number*
                        </label>
                        <input
                          type="text"
                          name="phoneNumber"
                          value={values.phoneNumber}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("phoneNumber")
                          }
                          placeholder="Please Enter Phone Number"
                          maxLength={15}
                        />
                        {errors.phoneNumber === false ? (
                          <div className="validationerror">
                            Please enter phone number{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label htmlFor="address" className="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          value={values.address}
                          name="address"
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("address")
                          }
                          placeholder="Please Enter Address"
                        />
                        {errors.address === false ? (
                          <div className="validationerror">Please address </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status*
                        </label>
                        <select
                          name="isActive"
                          value={values.isActive}
                          onChange={handleInputChange}
                          className={
                            "form-select" + applyErrorClass("phoneNumber")
                          }
                        >
                          <option value="">Please Select</option>
                          <option value="true">Active</option>
                          <option value="false">InActive</option>
                        </select>
                        {errors.isActive === false ? (
                          <div className="validationerror">Please select </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="staffs" className="form-label">
                          Created By
                        </label>
                        <select
                          value={values.staffId}
                          name="staffId"
                          onChange={handleInputChange}
                          className={"form-select" + applyErrorClass("staffId")}
                        >
                          <option value="00000000-0000-0000-0000-000000000000">
                            Please select
                          </option>
                          {staff.length > 0 &&
                            staff.map((c) => (
                              <option key={c.staffId} value={c.staffId}>
                                {c.staffName}
                              </option>
                            ))}
                        </select>
                        {errors.staffId === false ? (
                          <div className="validationerror">Please select </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="d-flex justify-content-end gap-2 mt-4">
                        {btnSubmit ? (
                          <button type="submit" className="btn btn-primary">
                            {values.clientId ===
                            "00000000-0000-0000-0000-000000000000"
                              ? "Submit"
                              : "Update"}
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled
                          >
                            Please wait...
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={resetForm}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modal.Body>
            </Modal>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Client Status</th>
                            <th>Client Code</th>
                            <th>Client</th>
                            <th>PAN</th>
                            <th>Status</th>
                            <th>Created By</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.clientId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>{v.statusOfClient}</td>
                                <td>{v.clientCode}</td>
                                <td>{v.clientName}</td>
                                <td>{v.panNumber}</td>
                                <td>
                                  <span
                                    className={`badge bg-${
                                      v.isActive ? "success" : "danger"
                                    } text-uppercase`}
                                  >
                                    {v.isActive ? "Active" : "Inactive"}
                                  </span>
                                </td>
                                <td>{v.staffName}</td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li>
                                      <Link
                                        className="view-item-btn"
                                        onClick={() => showClientDetails(v)}
                                      >
                                        <i className="ri-eye-fill text-muted" />
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill text-muted" />
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) => onDelete(e, v.clientId)}
                                      >
                                        <i className="ri-delete-bin-fill text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}

                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal show={showModal} onHide={closeModal}>
              <Modal.Header closeButton>
                <Modal.Title>Client Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedClient && (
                  <div>
                    <p>
                      <strong>Client Status:</strong>{" "}
                      {selectedClient.statusOfClient}
                    </p>
                    <p>
                      <strong>Client Code:</strong> {selectedClient.clientCode}
                    </p>
                    <p>
                      <strong>Group Code:</strong>{" "}
                      {selectedClient.clientGroupCode}
                    </p>
                    <p>
                      <strong>PAN Number:</strong> {selectedClient.panNumber}
                    </p>
                    <p>
                      <strong>Client Name:</strong> {selectedClient.clientName}
                    </p>
                    <p>
                      <strong>Date of Birth:</strong>{" "}
                      {selectedClient.dateOfBirth &&
                        moment(selectedClient.dateOfBirth).format(
                          "DD-MMM-YYYY"
                        )}
                    </p>
                    <p>
                      <strong>Company Name:</strong>{" "}
                      {selectedClient.companyName}
                    </p>
                    <p>
                      <strong>Email:</strong> {selectedClient.email}
                    </p>
                    <p>
                      <strong>Phone Number:</strong>{" "}
                      {selectedClient.phoneNumber}
                    </p>
                    <p>
                      <strong>Address:</strong> {selectedClient.address}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      {selectedClient.isActive ? "Active" : "Inactive"}
                    </p>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-danger" onClick={closeModal}>
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
}
